<template>
  <div class="container">
    <h4 class="cardD">Representantes orgánicos y apoderados</h4>

    <b-modal no-close-on-backdrop centered ref="modal-confirm-dialog" hide-footer id="modal-confirm-dialog">
      <h4 class="text-center">¿Seguro que quiere eliminar al representante o apoderado?</h4>
      <h5 class="text-center"></h5>
      <b-button class="mt-3" variant="danger" @click="$bvModal.hide('modal-confirm-dialog')">Cancelar</b-button>
      <b-button class="mt-3 float-right" variant="primary" @click="deleteApoderado">OK</b-button>
    </b-modal>

    <b-modal no-close-on-backdrop centered ref="apoderado-modal" title="" hide-footer id="modalC" size="xl">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(putApoderado)">
          <ModalApoderados
            :currentApoderado="currentApoderado"
            @submit.prevent
            :options_facultades="options_facultades"
            :complete="false"
          />
        </form>
      </ValidationObserver>
    </b-modal>

    <div class="row mt-5">
      <div class="col-12">
        <label for="">Apoderados</label>
        <b-button :disabled="constitutiva.disabled" variant="success" class="btn-fill spaceL" size="sm" @click="addApoderado">
          +
        </b-button>

        <b-table hover :fields="fieldsCuadro" :items="constitutiva.apoderados">
          <template #cell(acciones)="{ item }">
            <b-button
              :disabled="constitutiva.disabled"
              variant="warning"
              size="sm"
              v-b-tooltip.hover
              title="Editar"
              class="editBtn"
              @click="editApoderado(item)"
            >
              <b-icon-pencil />
            </b-button>
            <b-button
              :disabled="constitutiva.disabled"
              variant="danger"
              size="sm"
              v-b-tooltip.hover
              title="Eliminar"
              @click="predeleteApoderado(item.id)"
            >
              <b-icon-trash />
            </b-button>
          </template>
        </b-table>

        <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.apoderados.length > 1">
          La cotización básica incluye solo un apoderado.
        </label>
      </div>
    </div>

    <div class="col-6" v-if="false">
      <label for="">Exclusión de accionistas</label>

      <div v-if="constitutiva.roleStaff">
        <b-form-checkbox
          v-model="constitutiva.exclusion_accionistas"
          :disabled="constitutiva.disabledEspeciales"
        ></b-form-checkbox>
      </div>
      <div v-else>
        <b-form-checkbox v-model="constitutiva.exclusion_accionistas" :disabled="constitutiva.disabled"></b-form-checkbox>
      </div>

      <label class="mt-2 leyenda blue-text-important" v-if="constitutiva.exclusion_accionistas">
        La cotización básica no incluye esta opción.
      </label>
    </div>

    <div class="mt-12">
      <div class="">
        <b-button type="submit" class="btn-fill orange-btn bottom2" size="m" :disabled="constitutiva.disabled">
          Continuar
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import ModalApoderados from "@/views/clients/procesos/constitucion/infoBase/modales/ModalApoderados.vue";

export default {
  name: "RepresentantesYApoderados",

  components: {
    ModalApoderados,
  },

  created() {
    this.getFacultades();
  },

  props: {
    constitutiva: { type: Object },
    cat_facultades: { type: Array },
  },

  computed: {
    fieldsCuadro() {
      let fieldsCuadro = [
        { key: "index", label: "", class: "text-center" },
        { key: "nombre", label: "Nombre", class: "text-center" },
        { key: "paterno", label: "Paterno", class: "text-center" },
        { key: "materno", label: "Materno", class: "text-center" },
        // { key: "rfc", label: "RFC", class: "text-center" },
        { key: "acciones", label: "Acciones", class: "text-center" },
      ];
      return fieldsCuadro;
    },
  },

  data() {
    return {
      currentApoderado: null,
      currentApoderadoId: null,
      options_facultades: [],
      // cat_facultades: [],

      form: {
        apoderados: [],
      },
    };
  },

  methods: {
    selectBeneficiarioPLD(value) {
      this.constitutiva.beneficiario_pld = value;
    },

    selectBeneficiarioCFF(value) {
      this.constitutiva.beneficiario_cff = value;
    },

    async getFacultades() {
      this.loading = true;

      try {
        // const { value } = await CatFacultadesApi.list({
        //   page: 0,
        //   registersPerPage: 0,
        // });

        this.cat_facultades.forEach((element) => {
          this.options_facultades.push({
            text: element.facultad,
            value: element.facultad,
          });
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    addApoderado() {
      this.$refs["apoderado-modal"].show();
      this.currentApoderado = {};
    },

    editApoderado(item) {
      this.$refs["apoderado-modal"].show();
      this.currentApoderado = item;
    },

    putApoderado() {
      if (!this.currentApoderado.id) {
        const id = this.constitutiva.apoderados.length + 1;

        this.currentApoderado.id = id;

        const a = Object.assign({}, this.currentApoderado);

        this.constitutiva.apoderados.push(a);
      } else {
        const index = this.constitutiva.apoderados.findIndex((o) => o.id === this.currentApoderado.id);
        const a = Object.assign({}, this.currentApoderado);

        // this.constitutiva.apoderados[index] = a;
        this.constitutiva.apoderados.splice([index], 1, a);
      }

      this.$refs["apoderado-modal"].hide();
    },

    predeleteApoderado(id) {
      this.currentApoderadoId = id;

      this.$refs["modal-confirm-dialog"].show();
    },

    deleteApoderado() {
      const index2 = this.constitutiva.apoderados.findIndex((o) => o.id === this.currentApoderadoId);

      this.constitutiva.apoderados.splice(index2, 1);

      this.$refs["modal-confirm-dialog"].hide();
    },
  },
};
</script>

<style scoped>
.spaceL {
  margin-left: 1%;
}
</style>
